import "./bugsnag"
import * as bootstrap from "bootstrap"
import "./bootstrap_turbo_integration"
import "./turbo_submit_protection"
import "./turbo_frame_session_redirect"
import * as popper from "@popperjs/core"
import TomSelect from "tom-select"

globalThis.bootstrap = bootstrap
globalThis.Popper = popper
globalThis.TomSelect = TomSelect

// ES6-Shim - ECMAScript 6 compatibility shims for legacy JS engines.  Learn more: https://github.com/paulmillr/es6-shim
require("es6-shim/es6-shim.min.js");

// Initialize Bootstrap tooltips on page load and Turbo navigation
function initTooltips() {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  tooltipTriggerList.forEach(el => new bootstrap.Tooltip(el))

  // Also initialize tooltips on elements that can't use data-bs-toggle (e.g., modal triggers)
  const altTooltipTriggerList = document.querySelectorAll('[data-bs-tooltip="tooltip"]')
  altTooltipTriggerList.forEach(el => new bootstrap.Tooltip(el))
}

document.addEventListener("DOMContentLoaded", initTooltips)
document.addEventListener("turbo:load", initTooltips)
